const RelatorioConferenciasHome = () =>
  import(/* webpackChunkName: "group-pabx-relatorio" */ '../_views/RelatorioConferenciasHome')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'conferencias',
    component: RelatorioConferenciasHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'relatorio-conferencias',
  },
]
